export const StakeEvent = {
  StakePageView: 'stake_page_view',
  StakeButtonClick: 'stake_button_click',
  StakeTradingMultiplierClick: 'stake_trading_multiplier_click',
  StakeBecomeVipClick: 'stake_become_vip_click',
  StakeTradingMultiplierDepositButtonClick: 'stake_trading_multiplier_deposit_button_click',
  StakePercentageClick: 'stake_percentage_click',
  StakeConfirmClick: 'stake_confirm_click',
  StakeConvertToUsdtClick: 'stake_convert_to_usdt_click',
  UnstakeConfirmClick: 'unstake_confirm_click',
  UnstakeTextLinkClick: 'unstake_text_link_click',
  StakeAutoConvertClick: 'stake_auto_convert_click',
  StakeGoToEarnClick: 'stake_go_to_earn_click',
  StakeHedgeClick: 'stake_hedge_click',
  StakeHedgeProceedClick: 'stake_hedge_proceed_click',
  StakeHedgeTooltipView: 'stake_hedge_tooltip_view',
  StakeHedgeOrderClick: 'stake_hedge_order_click',
  StakeHedgeSolutionClick: 'stake_hedge_solution_click',
  LaunchpoolStakedAssetTradingEligibilityBottomsheetView:
    'launchpool_staked_asset_trading_eligibility_bottomsheet_view',
  LaunchpoolStakedAssetEligibilityConfirmClick: 'launchpool_staked_asset_eligibility_confirm_click',
} as const;

export interface StakeEventDataType {
  [StakeEvent.StakeButtonClick]: {
    symbol: string;
    apr?: string;
    reward_amount?: string;
    total_quantity?: string;
    my_quantity?: string;
    apr_vip?: number;
    vip_status?: 'TIER_STATUS_BASIC' | 'TIER_STATUS_VIP' | 'TIER_STATUS_VIP_GRACE' | 'TIER_STATUS_VIP_TRIAL';
  };
  [StakeEvent.StakeTradingMultiplierClick]: {
    symbol: string;
    multiplied_by?: number;
  };
  [StakeEvent.StakePercentageClick]: {
    symbol: string;
    percentage: string;
  };
  [StakeEvent.StakeBecomeVipClick]: {
    symbol: string;
  };
  [StakeEvent.StakeConfirmClick]: {
    symbol: string;
    quantity: string;
  };
  [StakeEvent.UnstakeTextLinkClick]: {
    symbol: string;
  };
  [StakeEvent.UnstakeConfirmClick]: {
    symbol: string;
  };
  [StakeEvent.StakeAutoConvertClick]: {
    currency: string;
    status: string;
    set_on: boolean;
    event_location: 'earn_launchpool_tab' | 'staking_complete_page';
  };
  [StakeEvent.StakeGoToEarnClick]: {
    button_text: string;
  };
  [StakeEvent.StakeHedgeClick]: {
    currency: string;
    event_location: string;
  };
  [StakeEvent.StakeHedgeProceedClick]: {
    currency: string;
  };
  [StakeEvent.StakeHedgeTooltipView]: {
    currency: string;
  };
  [StakeEvent.StakeHedgeOrderClick]: {
    currency: string;
  };
  [StakeEvent.StakeHedgeSolutionClick]: {
    currency: string;
    button_text: string;
  };
  [StakeEvent.LaunchpoolStakedAssetTradingEligibilityBottomsheetView]: Record<string, never>;
  [StakeEvent.LaunchpoolStakedAssetEligibilityConfirmClick]: Record<string, never>;
}
